import { NavLink } from "react-router";

const tab = ({ isActive }: { isActive: boolean }) => (isActive ? "active" : undefined);

export const TabBar = () => (
  <nav className="tabbar" aria-label="primary">
    <NavLink to="/" end className={tab}>
      <span className="icon">🏠</span>
      <span>Home</span>
    </NavLink>
    <NavLink to="/library" className={tab}>
      <span className="icon">📚</span>
      <span>Library</span>
    </NavLink>
    <NavLink to="/programs" className={tab}>
      <span className="icon">📋</span>
      <span>Workouts</span>
    </NavLink>
    <NavLink to="/history" className={tab}>
      <span className="icon">📈</span>
      <span>History</span>
    </NavLink>
    <NavLink to="/settings" className={tab}>
      <span className="icon">⚙️</span>
      <span>Settings</span>
    </NavLink>
  </nav>
);
